module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01"
    }
  }, [_vm._v("1. G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLD")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMP")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBELS")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSUS")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANKEES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01#h1"
    }
  }, [_vm._v("The Civil War through Words: Varina versus Virginia City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01#h2"
    }
  }, [_vm._v("Montana’s First Rebel Prisoner of War and Territorial Empire Builder: Nicholas Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01#h3"
    }
  }, [_vm._v("Ho! For the Gold Fields: The Fisk Family in War and in Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01#h4"
    }
  }, [_vm._v("Arming Montana: Arrival of the Military on the Upper Missouri")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTANA")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERRITORY")]), _vm._v(": F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORGED ON THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATTLEFIELD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Montana Territorial Governors Served in the Civil War: Democrat and Republican")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Legend and Mystery: General Thomas Francis Meagher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Congress to Governor of Montana Territory: Abolitionist James M. Ashley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gettysburg Hero and Territorial Montana Delegate: Major Martin Maginnis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Republican Man of Steel: Colonel Wilbur Fisk Sanders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROFILES IN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURAGE")]), _vm._v(": C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVIL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFICERS AND")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLISTED")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLDIERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Medal of Honor: Private Joseph O. Gregg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confederate Sharpshooter: Robert Chesnut")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Exceptional Warrior: Private James W. “Diamond R” Brown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A “Moss Backed Yankee” in a Rebel Uniform: Private Robert M. Craven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Larger-Than-Life Frontier Character: Colonel John J. Donnelly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fortunes Made and Fortunes Lost: Corporal William Scott Wetzel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Civil War to Library Founder: Private August Wedsworth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From “Pap” Price’s Army to Montana Territory: Sergeant John Byrd")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACK")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICANS")]), _vm._v(": F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROM")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MANCIPATION TO THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRING")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Death and Glory to Fort Shaw: Colonel Robert Gould Shaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Black American Warrior in the North: Private Alexander Branson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Embankments of Fort Wagner to the Barker Mines: Private Joseph W. Meek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Teenage Sergeant to Political Leader: Trailblazer Charles M. Meek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Union Sailor to Elected Great Falls Constable: Landsman William M. Morgan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Black and Slave Come to Montana Territory: James Wesley and Clarissa Jane Crump")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILDREN")]), _vm._v(", W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMEN")]), _vm._v(", M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(", F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMILIES")]), _vm._v(": I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTAL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Groomed on the Battlefield at Gettysburg: Young Brother Van")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teaching Former Slaves for the Freedmen’s Bureau: Harriet A. Lewis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Civil War Fighting Team: Colonel and Mrs. Francis Malone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Union Nurse on the Front Lines in the Civil War: Sarah Maranda Strong Vorus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Spy for the Union: Rebecca Norton of Missouri")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROM THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVIL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AR TO THE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDIAN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The French Aristocrat in America’s Civil and Indian Wars: Colonel Regis de Trobriand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Montana’s First Great Historian: Gallant Lieutenant James H. Bradley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Iron Brigade to the Montana Indian Wars: Colonel John Gibbon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dreams of Grandeur on the Backs of His Men: George Armstrong Custer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Christian General and Leader of Lincoln’s “Unfinished Work”: O.O. Howard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Prussia to Frontier Montana via the Civil and Indian Wars: Musician Robert F. Loss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGEND OF")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICTORY AND THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUSE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter07#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Great Falls Highland Cemetery Honors the Blue and the Gray")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter07#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Riverside Cemetery Honors Civil War Veterans: The Blue and the Gray")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter07#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chouteau County Civil War Veterans and the Grand Army of the Republic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter07#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helena’s Confederate Monument Honoring the Nostalgic Lost Cause Past")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0